import makeStore from "./index";

export const { store,persistor } = makeStore();


export default store;